import BigNumber from 'bignumber.js'
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Skeleton from 'UIKit/Skeleton'
import TokenLogo from 'UIKit/TokenLogo'
import { Token } from 'config/types'
import { RowBetween } from 'layout/Components/Row'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useTokenUsdPrice } from 'state/app/hooks'
import { useAuth } from 'state/auth/hooks'
import { useTokenSelected } from 'state/session/hooks'
import styled from 'styled-components'
import { getFullDisplayBalance } from 'utils/formatBalance'
import { InHouseGameNumericalInput, InHouseLabel, InhouseGameInputContainer } from 'views/InhouseGame/components/styled'

const InhouseTokenAmoutInput: React.FC<
  {
    betToken: Token
    disabled?: boolean
    value: string
    setValue: (value: string) => void
    label: string
  } & BoxProps
> = ({ disabled, label, value, setValue, betToken, ...props }) => {
  const { t } = useTranslation()
  const { isSigned } = useAuth()

  const selectedToken = useTokenSelected()
  const tokenInUsdPrice = useTokenUsdPrice(selectedToken)

  const estimateAmountInToken = useMemo(() => {
    return new BigNumber(value || '0').div(tokenInUsdPrice)
  }, [tokenInUsdPrice])

  return (
    <Flex flexDirection="column" {...props}>
      <RowBetween>
        <InHouseLabel>{t(label)}</InHouseLabel>
        {isSigned && (
          <InHouseLabel>
            {estimateAmountInToken ? (
              <>
                {getFullDisplayBalance(estimateAmountInToken, 0, 6)} {selectedToken.name}
              </>
            ) : (
              <Skeleton display="inline" minWidth="50px" ml="4px" minHeight="16px !important" />
            )}
          </InHouseLabel>
        )}
      </RowBetween>

      <StyledInhouseGameInputContainer disabled width="100%" height="38px" ml="4px">
        <InHouseGameNumericalInput
          disabled={disabled}
          placeholder="0"
          pl="12px"
          autoFocus={false}
          tabIndex={1}
          value={value}
          onValueChanged={(e) => {
            setValue(e.split('.')?.[0] ? e : e)
          }}
          style={{
            textAlign: 'left',
          }}
        />
        <Box pl="8px" pr="16px" minWidth={16}>
          <TokenLogo
            token={betToken}
            size={16}
            minWidth={16}
            networkImageProps={{
              width: 10,
              height: 10,
            }}
          />
        </Box>
      </StyledInhouseGameInputContainer>
    </Flex>
  )
}

const StyledInhouseGameInputContainer = styled(InhouseGameInputContainer)``

export default InhouseTokenAmoutInput
